<template>
  <div class="about">
    <HeaderBlock />
  </div>
</template>

<script>
import HeaderBlock from '@/components/header/HeaderBlock';
export default{
  name: 'ToolsView',
  components: {
    HeaderBlock
  }
};
</script>